enum QueryKeys {
  USER_EVENTS = "USER_EVENTS",
}

export default QueryKeys;
